<div class="page-body">
    <h1>Виртуальные лаборатории</h1>
    <a [routerLink]="['archimed']"
        >Тетрадь для лабораторных работ «Виртуальная лаборатория «Физика», раздел «АРХИМЕД</a
    >
    <a [routerLink]="['vizexmathtype']">Редактор формул VizExMathType</a>
    <div class="divider"></div>
    <a [routerLink]="['support']">Техническая поддержка</a>
    <a [routerLink]="['buy']"
        >Купите «Виртуальные лаборатории» для себя или своей школы прямо сейчас!</a
    >
</div>
